module.exports = __webpack_public_path__ + "static/media/thumbnail.d4735f91.jpg";